import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { Collection } from "../model/collections.model";
import { ContributionToken } from "../model/contribution-token.model";
import { Contribution } from "../model/contribution.model";
import { News } from "../model/news.model";
import { whitelistedAddress } from "../model/whitelisted-address.model";
import { contributionRule } from "../model/contribution-rule.model";
import { ConfirmedTransaction, Transaction } from "../model/transaction.model";
import { Faq } from "../model/faq.model";
import { Subscribe } from "../model/subscribe.model";
import { Project } from "../model/project.model";
import { StageRules } from "../model/stageRules.model";
import { Whitelist } from "../model/whitelist.model";
import { BlogsData } from "../model/blogs-data.model";
import { Field } from "../model/form-field.model";
const qs = require("qs");

@Injectable({
    providedIn: "root",
})
export class ApiService {
    constructor(private httpClient: HttpClient) {}
    public tokenSymbol: string;

    newsArray: News[];
    header = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTAsInJvbGUiOiJhZG1pbiIsImlzU3VwZXJBZG1pbiI6ZmFsc2UsIndhbGxldEFkZHJlc3MiOiIweDhBQTU1OUJEYTc5RGJBZjlmNWU0NTE3M0M0MUQ3NzAxYjNjYzhDMGUiLCJpYXQiOjE2ODI0Mzc3OTF9.I8Oqb9BGNrFzw6xxmwAf0D_vLgbI3BhfjZ6fpkwCbGc`,
    });

    getCrowdsaleData(contractAddress) {
        return this.httpClient.get(
            this._api_server + "/v2/crowdsales/" + contractAddress + "/data"
        );
    }

    getCrowdsaleBlogs(contractAddress: string, skip: number, take: number) {
        return this.httpClient.get<BlogsData>(
            this._api_server +
                "/v2/crowdsales/" +
                contractAddress +
                "/blogs/" +
                skip +
                "/" +
                take
        );
    }
    getSingleArticle(contractAddress: string, articleID: number) {
        return this.httpClient.get(
            this._api_server +
                "/v2/crowdsales/" +
                contractAddress +
                "/blogs/" +
                articleID
        );
    }

    applyForDemo(
        firstName: string,
        lastName: string,
        email: string,
        companyName: string,
        companyRole: string,
        reference: string,
        demoPurpose: string,
        desiredDate: number,
        websiteURL: string
    ) {
        return this.httpClient.post(this._api_server + "/v2/demos", {
            firstName,
            lastName,
            email,
            companyName,
            companyRole,
            reference,
            demoPurpose,
            desiredDate,
            websiteURL,
        });
    }

    getWhitelistRequirements(crowdsaleAddress: string) {
        return this.httpClient.get(
            this._api_server +
                "/v2/crowdsales/" +
                crowdsaleAddress +
                "/whitelistRequirements",
            { headers: this.header }
        );
    }

    applyForWhitelist(
        crowdsaleAddress: string,
        walletAddress: string,
        stageId: number,
        fields: Field[]
    ) {
        return this.httpClient.post(
            this._api_server +
                "/v2/crowdsales/" +
                crowdsaleAddress +
                "/applyForWhitelist",
            { walletAddress, stageId, fields },
            { headers: this.header }
        );
    }

    checkIsWalletWhitelisted(walletAddress: string, stageId: number) {
        return this.httpClient.get(
            this._api_server + "/v2/crowdsales/" + walletAddress + "/" + stageId
        );
    }

    // private _api_server = `${environment.STRAPI_API_KEY}`;
    // private _api_server = "http://localhost:1337/api";
    private _api_server = `${environment.API_ADDRESS}`;

    getContributionToken(tokenAddress: string) {
        return this.httpClient.get(
            this._api_server +
                "/v2/crowdsales/" +
                tokenAddress +
                "/contributionToken",
            { headers: this.header }
        );
    }

    getAllTransactions(
        crowdsaleID: number,
        skip: number,
        take: number
    ): Observable<any> {
        return this.httpClient.get(
            this._api_server +
                "/v2/crowdsales/" +
                crowdsaleID +
                "/transactions/" +
                skip +
                "/" +
                take
        );
    }

    getTransactionsForWallet(walletAddress: string) {
        return this.httpClient.get(
            this._api_server + "/v2/wallets/" + walletAddress + "/transactions"
        );
    }

    getCrowdsaleArticles(crowdsaleID: number) {
        return this.httpClient.get(
            this._api_server + "/v2/crowdsales/" + crowdsaleID + "/articles"
        );
    }

    setResource(url: string): void {
        // this._api_server = this._api_server + url;
    }
    insertTransaction(txData): Observable<Transaction[]> {
        return this.httpClient.post<Transaction[]>(
            this._api_server + "/transactions",
            txData,
            { headers: this.header }
        );
    }
    getContributionPerUser(walletAddress): Observable<Transaction[]> {
        return this.httpClient.get<Transaction[]>(
            this._api_server + "/transactions/getByAddress/" + walletAddress,
            {
                headers: this.header,
            }
        );
    }
    getSubmittedTx(): Observable<Transaction[]> {
        return this.httpClient.get<Transaction[]>(
            this._api_server + "/transactions/active",
            {
                headers: this.header,
            }
        );
    }
    updateTransactionSetConfirmed(id, status): Observable<Transaction[]> {
        const txUpdateData = {
            uniqueID: id,
            statusOfTx: status,
        };
        return this.httpClient.put<Transaction[]>(
            this._api_server + "/transactions/confirmed",
            txUpdateData,
            {
                headers: this.header,
            }
        );
    }
    getListOfTx(addressArray): Observable<Transaction[]> {
        return this.httpClient.post<Transaction[]>(
            this._api_server + "/transactions/getListOfTx",
            addressArray,
            {
                headers: this.header,
            }
        );
    }
    getStageRules(id): Observable<StageRules[]> {
        return this.httpClient.get<StageRules[]>(
            this._api_server + "/crowdsales/stageRules/" + id,
            {
                headers: this.header,
            }
        );
    }
    getTransactionPerAddress(address): Observable<Transaction[]> {
        return this.httpClient.get<Transaction[]>(
            this._api_server + "/transactions/getByAddress/" + address,
            {
                headers: this.header,
            }
        );
    }
    getWhiteListStatus(crowdsaleId, address): Observable<Whitelist[]> {
        return this.httpClient.get<Whitelist[]>(
            this._api_server +
                "/stages/whitelist/" +
                crowdsaleId +
                "/" +
                address,
            {
                headers: this.header,
            }
        );
    }
    getCurrentWhitelistStatus(crowdsaleId) {
        return this.httpClient.get(
            this._api_server + "/stages/whitelist/status/" + crowdsaleId,
            {
                headers: this.header,
            }
        );
    }
    changeCurrentWhitelistStatus(whitelistID, status) {
        let data = {
            whitelistID: whitelistID,
            status: status,
        };
        return this.httpClient.put(
            this._api_server + "/stages/whitelist",
            data,
            {
                headers: this.header,
            }
        );
    }
    addUserToWHitelist(userData) {
        let userPostData = {
            whitelistID: 1,
            walletAddress: userData.walletAddress,
        };
        return this.httpClient.put(
            this._api_server + "/stages/whitelist/removeWallet",
            userPostData,
            {
                headers: this.header,
            }
        );
    }
    getStageRulesWithStageInfo(currentStage) {
        return this.httpClient.get(
            this._api_server + "/crowdsales/stageRules/" + currentStage,
            {
                headers: this.header,
            }
        );
    }
    getCurrentActiveStageu() {
        return this.httpClient.get(this._api_server + "/", {
            headers: this.header,
        });
    }
    getSumPerActiveStage(crowdsaleID) {
        return this.httpClient.get(
            this._api_server + "/crowdsales/totalContribs/" + crowdsaleID,
            {
                headers: this.header,
            }
        );
    }
    getActiveStage(crowdsaleID) {
        return this.httpClient.get(
            this._api_server + "/crowdsales/activeStage/" + crowdsaleID,
            {
                headers: this.header,
            }
        );
    }
    /**
     *
     * @param query Query by which to filter news
     * @returns News object/s
     */
    getNews(query = ""): Observable<News[]> {
        // return this.httpClient.get<News[]>(this._api_server + "/posts" + query, { headers: this.header });
        return this.httpClient.get<News[]>("/posts");
    }

    /**
     * Function is deprecated.
     * @param address Current users wallet address
     * @returns Inserted Whitelist object
     */
    insertWhitelistedAddress(
        address: string
    ): Observable<whitelistedAddress[]> {
        let today: string = new Date().toISOString().slice(0, 10); // Strapi doesnt support todays date as default.
        let postData = { data: { Address: address, dateAdded: today } };
        return this.httpClient.post<whitelistedAddress[]>(
            this._api_server + "/whitelisted-addresses",
            postData,
            { headers: this.header }
        );
        // console.log(a);
        // return a;
    }

    /**
     *
     * @param addr Current users wallet address
     * @returns whitelistedAddress object -- needed to see status
     */
    getCurrentWhiteListStatus(addr) {
        return this.httpClient.get<whitelistedAddress[]>(
            this._api_server + "/whitelisted-addresses" + addr,
            { headers: this.header }
        );
    }
    /**
     *
     * @param data Object which contains data from form
     * @returns Inserted collection object
     */
    insertCollections(data: any): Observable<Collection[]> {
        let postData = {
            data: {
                name: data["name"],
                last_name: data["last_name"],
                Email: data["Email"],
                ContributionWallet: data["ContributionWallet"],
                ContributionAmount: data["ContributionAmount"],
            },
        };

        return this.httpClient.post<Collection[]>(
            this._api_server + "/collections",
            postData,
            { headers: this.header }
        );
    }

    /**
     *
     * @param tokenName Name of token that use wants to buy - is actually a Filter for strapi query
     * @returns contribution object (User balance and address)
     */
    getContribToken(tokenName: string): Observable<ContributionToken[]> {
        return this.httpClient.get<ContributionToken[]>(
            this._api_server + "/contribution-tokens" + tokenName,
            { headers: this.header }
        );
    }

    getContributionRules() {
        return this.httpClient.get<any>(this._api_server + "/");
    }

    /**
     *
     * @param address
     * @param tokenAmount
     * @returns Object - success
     */
    buyTokens(
        address: string,
        tokenAmount: number
    ): Observable<Contribution[]> {
        let postData = { data: { address: address, Balance: tokenAmount } };
        return this.httpClient.post<Contribution[]>(
            this._api_server + "/contributions",
            postData,
            { headers: this.header }
        );
    }

    updateTokens(
        userId: number,
        tokenAmount: number,
        userBought: number
    ): Observable<Contribution[]> {
        tokenAmount = tokenAmount + userBought;
        let putData = { data: { Balance: tokenAmount } };
        console.log(this._api_server + "/contributions/" + userId);
        return this.httpClient.put<Contribution[]>(
            this._api_server + "/contributions/" + userId,
            putData,
            { headers: this.header }
        );
    }
    /**
     *
     * @param tokenName Name of token that user is trying to buy
     * @param tokenAmount Amount of tokens that is alredy bought
     * @param tokenAmountUser Amount of tokens that user had bought
     */
    updateContributionToken(
        tokenId: number,
        tokenAmount: number,
        tokenAmountUser: number,
        totalAvailable: number
    ): Observable<ContributionToken[]> {
        totalAvailable = totalAvailable - tokenAmountUser;
        tokenAmount = tokenAmount + tokenAmountUser;

        let postData = {
            data: { totalBacked: tokenAmount, totalAvailable: totalAvailable },
        };
        // ?filters[tokenName][$eq]=
        return this.httpClient.put<ContributionToken[]>(
            this._api_server + "/contribution-tokens/" + tokenId,
            postData,
            { headers: this.header }
        );
    }

    /**
     *
     * @param address Address of current users wallet.
     * @returns Object that contains users balance
     */
    // getUserBalance(address: string) : Observable<Contribution[]>{
    //   return this.httpClient.get<Contribution[]>(this._api_server+"/contributions", {headers: this.header});
    // }
    /**
     * Fetch contribution rule (Currently there is only one, hence no conditions)
     * @returns object containing contribution rules
     */
    getContributionRule(): Observable<contributionRule[]> {
        return this.httpClient.get<contributionRule[]>(
            this._api_server + "/contribution-rules",
            { headers: this.header }
        );
    }
    /**
     *
     * @param optionalArguments Optional arguments for query, eg. where field = value, E.G ?[field][$eq]='someValue'
     * @returns transaction object
     */
    getTransactions(optionalArguments = ""): Observable<Transaction[]> {
        return this.httpClient.get<Transaction[]>(
            this._api_server + "/transactions" + optionalArguments,
            { headers: this.header }
        );
    }
    /**
     *
     * @param argv same sa getTransaction, an optional argument
     * @returns collection object
     */
    getCollection(optionalArguments = ""): Observable<Collection[]> {
        return this.httpClient.get<Collection[]>(
            this._api_server + "/collections/" + optionalArguments,
            { headers: this.header }
        );
    }

    /**
     *
     * @param address Address of current user
     * @param amount Contributed amount
     * @param txHash Transaction hash (Recieved when sending TX)
     * @returns
     */
    // insertTransaction(txHash, amount, userUniqueID) {
    //     let postData = {
    //         data: {
    //             txHash: txHash,
    //             amount: amount,
    //             statusOfTx: "incoming",
    //             userUniqueID: 1,
    //         },
    //     };
    //     return this.httpClient.post<Transaction[]>(
    //         "0.0.0.0:3100/transactions",
    //         postData,
    //         { headers: this.header }
    //     );
    // }

    /**
     *
     * @param id Id by which to find transaction
     * @returns Observable
     */
    updateTransaction(id): Observable<Transaction[]> {
        let putData = { data: { status: "processed" } };
        return this.httpClient.put<Transaction[]>(
            this._api_server + "/transactions/" + id,
            putData,
            { headers: this.header }
        );
    }

    /**
     *
     * @param id
     * @returns Observable
     */
    corruptTransaction(id): Observable<Transaction[]> {
        let putData = { data: { status: "corrupted" } };
        return this.httpClient.put<Transaction[]>(
            this._api_server + "/transactions/" + id,
            putData,
            { headers: this.header }
        );
    }
    /**
     *
     * @param txA (Optional) Array of transactions which need to be found
     * @returns Observale of Transactions
     */
    // getListOfTx(txA): Observable<Transaction[]> {
    //     const query = qs.stringify(
    //         {
    //             filters: {
    //                 txHash: {
    //                     $in: txA,
    //                 },
    //             },
    //         },
    //         {
    //             encodeValuesOnly: true, // prettify url
    //         }
    //     );
    //     return this.httpClient.get<Transaction[]>(
    //         this._api_server + "/transactions?" + query,
    //         { headers: this.header }
    //     );
    // }

    /**
     *
     * @param to User that recieves the email
     * @param amount Amount of USDC that the user backed
     * @returns void
     */
    sendEmail(to, amount = 0) {
        // amount = 1000;
        // to='marcelbockovac2@gmail.com'
        let postData = {
            data: {
                from: "test@beyondi.ninja",
                subject: "You have contributed to the seed round",
                to: to,
                text:
                    "You have successfully contributed to LitBit seed round with the amount of: " +
                    amount +
                    " TCRO",
            },
        };
        // return this.httpClient.post("https://strapi-litbit-test.beyondi.ninja/api/mailer/send", postData, {headers: this.header})
        return this.httpClient.post(
            "https://strapi-litbit-test.beyondi.ninja/api/pages-report",
            postData,
            { headers: this.header }
        );
    }

    sendEmailGET() {
        return this.httpClient.get(this._api_server + "/mailer/send", {
            headers: this.header,
        });
    }
    /**
     *
     * @param data Data that needs to be inserted for contact message from contact us page
     * @returns void
     */
    insertContactMessage(data) {
        console.log(data);
        let postData = {
            data: {
                Name: data["Name"],
                Email: data["Email"],
                Subject: data["Subject"],
                Message: data["Message"],
            },
        };
        console.log(postData);
        return this.httpClient.post(
            this._api_server + "/contact-messages",
            postData,
            { headers: this.header }
        );
    }

    getFaq(id) {
        return this.httpClient.get<Faq[]>(
            this._api_server + "/v2/crowdsales/" + id + "/faqsAndNews",
            { headers: this.header }
        );
    }

    postSubscription(userEmail) {
        let postData = {
            data: {
                userEmail: userEmail,
            },
        };
        return this.httpClient.post<Subscribe>(
            this._api_server + "/subscribe-emails",
            postData,
            { headers: this.header }
        );
    }

    getProjectData(projectId) {
        let query = "?filters[id][$eq]=" + projectId;
        return this.httpClient.get<Project>(this._api_server + "/projects", {
            headers: this.header,
        });
    }
    getTransactionByAddress(walletAddress: string) {
        return this.httpClient.get<Transaction>(
            this._api_server + "/transactions/getByAddress/" + walletAddress,
            { headers: this.header }
        );
    }
    getStaticPages(id) {
        return this.httpClient.get(
            this._api_server + "/v2/crowdsales/" + id + "/staticPages",
            { headers: this.header }
        );
    }
}
